/* @ngInject */
function OrganizedController ($rootScope, $location, $scope, $translate, $q, $window, $timeout, $stateParams, $state, AdminService, RepositoryService, AssetPreviewService, UdsModalService, Utils, ToastService, SegmentService) {
  const getCreateFolderDialogController = () => $q.when(import('../../dialogs/create-folder/create-folder-dialog.controller'))
  const getMoveToTrashDialogController = () => $q.when(import('../../dialogs/move-to-trash/move-to-trash-dialog.controller'))
  const getUpgradeCompanyPlanDialogController = () => $q.when(import('../../../core/dialogs/upgrade-company-plan/upgrade-company-plan-dialog.controller'))
  const getModulesPricingDialogController = () => $q.when(import('../../../core/dialogs/modules-pricing/modules-pricing-dialog.controller'))
  const getChooseDocTemplateDialogController = () => $q.when(import('../../dialogs/choose-doc-template/choose-doc-template-dialog.controller'))

  $scope.hasShowMoreButton = false
  $scope.currentPage = 'organized'
  $scope.currentFolder = {}
  $scope.initialLoad = true
  $scope.pagination = {
    $sort: 'latestUpdates',
    $order: 'DESC',
    $top: 30,
    $skip: 0
  }
  $scope.companyFeatures = {
    importFiles: {
      access: true
    }
  }

  $scope.sections = [
    { slug: 'folders', assets: [], totalCount: 0 },
    { slug: 'materials', assets: [], totalCount: 0 }
  ]
  $scope.searchSections = [
    { slug: 'organized-search', assets: [], totalCount: 0 }
  ]

  $scope.assetSearch = null
  $scope.searching = false
  $scope.filters = {
    extension: null,
    type: null,
    tags: null,
    excludeExtensions: null
  }

  let advancedSearchFilters = null

  const api = {
    getMoveToTrashDialogController,
    getCreateFolderDialogController,
    getUpgradeCompanyPlanDialogController,
    getModulesPricingDialogController,
    getChooseDocTemplateDialogController,
    _openPricingUpgradeDialog,
    _reloadAssetsAfterUploadHandler,
    _hasFilterApplied,
    _hasOrganizedAccess,
    _setEmptyState,
    _handlePricing,
    _removeAssetFromList,
    _handleAdvancedSearch,
    _handleAdvancedFilters,
    _setHeader,
    _resetAllSections,
    _searchAssets,
    _clearSearch,
    _loadAssets,
    _hasMoreResults,
    _addFolder,
    _loadFolders,
    _onAdvancedSearchAssetClick,
    _openMoveToTrashDialog,
    _importFiles,
    _successGetFolderById,
    _errorGetFolderById,
    _handleGoBackFolder,
    _formatBreadcrumbs,
    _handleOpenFolder,
    _getBreadcrumbs,
    _trackSearch,
    _removeAssetsFromList,
    _openChooseDocTemplateDialog
  }

  this.getApi = () => api

  $scope.emptyState = null
  $scope.breadcrumbs = {
    show: false,
    history: [],
    current: null,
    root: { id: null, title: $translate.instant('repository.sidebarSections.organized') },
    onChange: api._handleOpenFolder
  }

  $scope.searching = false
  let title = ''

  $translate.onReady(() => {
    $rootScope.getUser().then((oUser) => {
      title = $translate.instant('repository.sidebarSections.organized')
      const allUsedInOptions = [
        { label: $translate.instant('materials'), value: 'arts', slug: 'ARTS.ACCESS' },
        { label: $translate.instant('posts'), value: 'posts', slug: 'POSTS.ACCESS' },
        { label: $translate.instant('checklist'), value: 'checklist', slug: 'CHECKLIST.ACCESS' },
        { label: $translate.instant('dashboard.brandSettings'), value: 'brand', slug: 'BRAND.ACCESS' },
        { label: $translate.instant('requests'), value: 'workflow', slug: 'WORKFLOW.ACCESS' }
      ]

      $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
        const usedInOptions = allUsedInOptions.filter(option => features[String(option.slug)])
        const hasTagsFeature = !!features['REPOSITORIES.TAGS']

        advancedSearchFilters = [
          {
            name: 'tags',
            type: 'INPUT_MULTISELECT',
            grouped: false,
            defaultValue: [],
            props: {
              label: $translate.instant('repository.filters.filterByTags'),
              placeholder: $translate.instant('repository.filters.typeTags'),
              emptyMsg: $translate.instant('noResults'),
              loadButtonLabel: $translate.instant('loadMore'),
              type: 'tag',
              hasMoreOptions: true,
              udsDisabled: false,
              options: [],
              pricing: {
                show: !hasTagsFeature,
                tooltip: $translate.instant('billingTooltips.haveMoreWithPro'),
                tooltipPosition: 'top',
                onClick: () => {
                  api._openPricingUpgradeDialog($translate.instant('tags'), 'REPOSITORIES.TAGS')
                }
              }
            },
            loadData: (search, top, skip) => RepositoryService.getAllAssetTags({ top, skip }, search)
          },
          {
            name: 'designers',
            type: 'INPUT_MULTISELECT',
            grouped: true,
            defaultValue: [],
            props: {
              label: $translate.instant('repository.filters.accessByDesigner'),
              placeholder: $translate.instant('selectPlaceholder'),
              emptyMsg: $translate.instant('noResults'),
              loadButtonLabel: $translate.instant('loadMore'),
              type: 'user',
              hasMoreOptions: true,
              udsDisabled: false,
              options: []
            },
            loadData: (search, top, skip) => AdminService.getUsers(top, skip, { search, role: ['DESIGNER'], active: true })
          },
          {
            name: 'createdBy',
            type: 'INPUT_MULTISELECT',
            grouped: true,
            defaultValue: [],
            props: {
              label: $translate.instant('repository.filters.createdBy'),
              placeholder: $translate.instant('selectPlaceholder'),
              emptyMsg: $translate.instant('noResults'),
              loadButtonLabel: $translate.instant('loadMore'),
              type: 'user',
              hasMoreOptions: true,
              udsDisabled: false,
              options: []
            },
            loadData: (search, top, skip) => AdminService.getUsers(top, skip, { search })
          },
          {
            name: 'modules',
            type: 'INPUT_MULTISELECT',
            grouped: true,
            defaultValue: [],
            props: {
              label: $translate.instant('repository.filters.usedIn'),
              placeholder: $translate.instant('selectPlaceholder'),
              emptyMsg: $translate.instant('noResults'),
              type: 'text',
              hasMoreOptions: false,
              udsDisabled: false,
              options: []
            },
            loadData: search => {
              const deferred = $q.defer()

              if (search) {
                const filteredItems = Utils.searchByArray(usedInOptions, search)
                deferred.resolve({
                  rows: filteredItems,
                  count: filteredItems.length
                })
              }

              if (!search) {
                deferred.resolve({
                  rows: usedInOptions,
                  count: usedInOptions.length
                })
              }

              return deferred.promise
            }
          },
          {
            name: 'assetId',
            type: 'INPUT',
            grouped: true,
            defaultValue: [],
            props: {
              label: $translate.instant('repository.filters.idCode'),
              placeholder: $translate.instant('repository.filters.typeCode'),
              type: 'text',
              udsDisabled: false
            }
          },
          {
            name: 'createdAt',
            type: 'DATE_PICKER',
            grouped: true,
            defaultValue: '',
            props: {
              locale: oUser.locale,
              label: $translate.instant('repository.filters.creationDate'),
              firstDayOfWeek: '1',
              direction: 'right'
            }
          }, {
            name: 'updatedAt',
            type: 'DATE_PICKER',
            grouped: true,
            defaultValue: '',
            props: {
              locale: oUser.locale,
              label: $translate.instant('repository.filters.changeDate'),
              firstDayOfWeek: '1',
              direction: 'right'
            }
          }, {
            name: 'customFields',
            props: {
              mustShowCustomFields: true
            }
          }
        ]

        return $rootScope.getCompanyFeatures().then((companyFeatures) => {
          $scope.hasDocAccess = companyFeatures.includes('DOCUMENTS_MODULE')
          api._setHeader()
        })
      })
    })
  })

  function _importFiles (event) {
    const { pricing } = event.currentTarget

    if (pricing) {
      return api._openPricingUpgradeDialog($translate.instant('addFiles'), 'REPOSITORIES.IMPORT_MATERIALS')
    }

    $window.showOpenFilePicker({
      multiple: true
    }).then((filesInstances) => {
      if (!filesInstances?.length) {
        return
      }

      const mappedFiles = filesInstances.map((file) => file.getFile())
      return Promise.all(mappedFiles).then((files) => {
        $rootScope.$emit('upload-tab.upload-new-assets', files, { folderId: $scope?.currentFolder?.id, isOrganized: true })
      })
    })
  }

  function activate () {
    const folderId = !$scope.modalState ? $stateParams.id : null

    api._hasOrganizedAccess().then((hasOrganizedAccess) => {
      api._setEmptyState(hasOrganizedAccess)

      if (!folderId) {
        $stateParams.pageHistory = []
      }

      if (folderId && !$scope.modalState) {
        $scope.breadcrumbs.show = true
        RepositoryService.getFolderById(folderId, false)
          .then(api._successGetFolderById)
          .catch(api._errorGetFolderById)
      }

      api._loadFolders(null, folderId)
        .then(() => {
          api._loadAssets(folderId)
            .then(() => {
              const allSectionsAreEmpty = $scope.sections.every(section => !section.assets.length)

              if (hasOrganizedAccess) {
                $scope.emptyState = {
                  imgPath: 'empty-state-' + $scope.currentPage,
                  title: $translate.instant('repository.emptyState.organized.title'),
                  message: $translate.instant('repository.emptyState.organized.message'),
                  button: {
                    type: 'primary',
                    icon: $scope.modalState && !allSectionsAreEmpty ? 'arrow-left' : 'plus',
                    text: $scope.modalState && !allSectionsAreEmpty ? 'backPage' : 'repository.emptyState.organized.buttonText',
                    click: $scope.modalState && !allSectionsAreEmpty ? api._handleGoBackFolder.bind() : api._addFolder.bind()
                  }
                }
              }

              $timeout(() => {
                $scope.initialLoad = false
              }, 2000)
            })
        })
    })
  }

  activate()

  function _successGetFolderById (folder) {
    if (!folder) {
      ToastService.defaultErrorToast()
      $state.go('repository.organized')
    }

    $scope.currentFolder = folder
    $scope.breadcrumbs.current = folder
    $scope.headerTitle = $scope.currentFolder.title

    if (!$stateParams.pageHistory || !$stateParams.pageHistory.length ||
      $stateParams.pageHistory.find(item => item.id === folder.id)
    ) {
      return api._getBreadcrumbs(folder)
    }

    $scope.breadcrumbs.history = $stateParams.pageHistory
    $scope.breadcrumbs.history.push(folder)

    $stateParams.pageHistory = $scope.breadcrumbs.history

    api._formatBreadcrumbs()
  }

  function _errorGetFolderById () {
    ToastService.defaultErrorToast()
  }

  function _handleOpenFolder (folder) {
    api._resetAllSections()
    $scope.currentFolder = folder
    $scope.$broadcast('repository.load-assets-start')
    $scope.$emit('organized.opened-folder', folder)

    if (!$scope.modalState) {
      if (!folder.id) {
        return $state.go('repository.organized')
      }

      if (Number($stateParams.id) === folder.id) {
        return $state.reload('repository.organizedFolder')
      }

      return $state.go('repository.organizedFolder', {
        id: folder.id
      })
    }

    api._loadFolders(null, folder.id)
      .then(() => {
        $scope.breadcrumbs.current = folder

        api._loadAssets(folder.id)
          .then(() => {
            $scope.initialLoad = false
          })
      })
  }

  $scope.handleOpenFolder = api._handleOpenFolder

  function _getBreadcrumbs (folder) {
    RepositoryService.getFolderPath(folder.id)
      .then((folderPath) => {
        $scope.breadcrumbs.history = folderPath
        $scope.breadcrumbs.history.unshift($scope.breadcrumbs.root)

        $stateParams.pageHistory = $scope.breadcrumbs.history

        api._formatBreadcrumbs()
      })
  }

  function _formatBreadcrumbs () {
    $scope.breadcrumbs.items = $scope.breadcrumbs.history.map(item => {
      return {
        ...item,
        label: item.title
      }
    })
  }

  function _handleGoBackFolder () {
    const parentFolder = {
      id: $scope.currentFolder.parentId || null
    }

    $scope.handleOpenFolder(parentFolder)
  }

  function _reloadAssetsAfterUploadHandler () {
    api._resetAllSections()

    api._loadFolders(false, $scope.breadcrumbs?.current?.id).then(() => {
      api._loadAssets($scope.breadcrumbs?.current?.id)
    })
  }

  $scope.handleGoBackFolder = api._handleGoBackFolder

  const deregisterReloadAssetsAfterUpload = $rootScope.$on('reload-assets-after-upload', api._reloadAssetsAfterUploadHandler)

  const deregisterReloadFoldersArchive = $rootScope.$on('repository.organized.reload-folders', (event, archivedFolderId) => {
    const assetIndex = $scope.sections[0].assets.findIndex(sectionFolder => sectionFolder.id === archivedFolderId)

    $scope.sections[0].assets.splice(assetIndex, 1)
    $scope.sections[0].assets.totalCount--
  })

  const deregisterSelectAssetsSortOrder = $rootScope.$on('select-assets-sort-order', (e, file) => {
    $scope.pagination.$sort = file.sort
    $scope.pagination.$order = file.order
    api._resetAllSections()

    api._loadFolders(false, $scope.breadcrumbs?.current?.id)
      .then(() => {
        api._loadAssets($scope.breadcrumbs?.current?.id)
      })
  })

  $scope.$watchCollection('headerToolbar.repositoryFilter.params', (fileTypes) => {
    if ($scope.initialLoad) {
      return
    }

    let fileType = null
    let shouldReloadFolders = false

    for (const type in fileTypes) {
      if (fileTypes[type]) {
        shouldReloadFolders = false
        fileType = type
        break
      }

      shouldReloadFolders = true
    }

    $scope.filters.type = fileType
    $scope.filters.extension = null

    api._searchAssets()

    if (shouldReloadFolders) {
      api._loadFolders(false, $scope.breadcrumbs?.current?.id)
    }
  })

  const deregisterExtensionFilterUpdate = $scope.$on('repository-filters.extension-filter-update', (_, extension) => {
    $scope.filters.extension = extension

    api._resetAllSections()
    api._loadAssets($scope.breadcrumbs?.current?.id)

    if (extension === 'all') {
      api._loadFolders(false, $scope.breadcrumbs?.current?.id)
    }
  })

  const deregisterOnAttachModalSearch = $scope.$on('attach-asset-modal.search', (_, term) => {
    $scope.assetSearch = term

    if (!term) {
      return api._clearSearch()
    }

    api._handleAdvancedSearch($scope.assetSearch, [])
  })

  const deregisterReloadFolders = $scope.$on('repository-organized.reload-folders', (_, parentId) => {
    api._loadFolders(false, parentId)
  })

  const deregisterAssetsArchive = $scope.$on('repository.assets-archive', (e, archivedAssets) => {
    api._removeAssetsFromList(archivedAssets)
  })

  function _removeAssetsFromList (selectedAssets) {
    $timeout(() => {
      selectedAssets.forEach((selectedAsset) => {
        const assetIndex = $scope.sections[1].assets.findIndex(asset => asset.id === selectedAsset.id)
        if (assetIndex >= 0) {
          $scope.sections[1].assets.splice(assetIndex, 1)
          $scope.sections[1].totalCount--
        }
      })
      $scope.selectedAssets = []
    })
  }

  $scope.$on('$destroy', () => {
    deregisterOnAttachModalSearch()
    deregisterExtensionFilterUpdate()
    deregisterReloadAssetsAfterUpload()
    deregisterReloadFolders()
    deregisterSelectAssetsSortOrder()
    deregisterAssetsArchive()
    deregisterReloadFoldersArchive()
  })

  function _setHeader () {
    const headerInfo = RepositoryService.getHeader(
      $scope.searching,
      title,
      {
        hasAdvancedSearch: true,
        hasFilters: true,
        searchAssets: api._handleAdvancedSearch,
        clearSearch: api._clearSearch,
        onSearchAssetClick: api._onAdvancedSearchAssetClick,
        advancedFilters: advancedSearchFilters,
        onFilter: api._handleAdvancedFilters
      }
    )

    if ($scope.filters.type) {
      headerInfo.headerToolbar.repositoryFilter.params.all = false
      headerInfo.headerToolbar.repositoryFilter.params[$scope.filters.type] = true
    }

    Promise.all([
      api._hasOrganizedAccess(),
      api._handlePricing()
    ]).then(([hasOrganizedAccess]) => {
      const createNewButton = $scope.hasDocAccess ? {
        type: 'dropdown',
        btnType: 'secondary',
        label: $translate.instant('createNew'),
        dropdownPosition: 'right',
        icon: 'plus',
        options: [
          {
            icon: 'deskfy-file',
            label: $translate.instant('document'),
            onClick: api._openChooseDocTemplateDialog
          }
        ]
      } : null

      const rightButtons = [
        createNewButton,
        {
          type: 'dropdown',
          btnType: 'primary',
          icon: 'chevron-down',
          iconPosition: 'right',
          label: $translate.instant('repository.add'),
          options: [
            {
              label: $translate.instant('attachAssetsWorkflow.importFromDevice'),
              icon: 'upload',
              onClick: api._importFiles,
              pricing: {
                tooltip: $translate.instant('billingTooltips.haveMoreWithPro'),
                position: 'left',
                plan: 'Pro',
                prop: !$scope.companyFeatures.importFiles.access || !hasOrganizedAccess
              }
            },
            {
              label: $translate.instant('addCollection'),
              icon: 'folder-plus',
              onClick: api._addFolder,
              pricing: {
                tooltip: $translate.instant('billingTooltips.haveMoreWithPro'),
                position: 'left',
                plan: 'Pro',
                prop: !$scope.companyFeatures.importFiles.access || !hasOrganizedAccess
              }
            }
          ]
        }
      ]

      $timeout(() => {
        $scope.headerTitle = $scope.currentFolder?.title ? $scope.currentFolder.title : headerInfo.headerTitle
      }, 200)

      headerInfo.headerToolbar.rightButtons = rightButtons
      $scope.headerToolbar = headerInfo.headerToolbar
      $scope.headerNavigation = headerInfo.headerNavigation
      $scope.headerTitle = headerInfo.headerTitle
    })
  }

  function _handleAdvancedFilters (filters) {
    if ($scope.initialLoad) {
      return
    }

    if (!filters || !api._hasFilterApplied(filters)) {
      $scope.filters = {}

      if ($scope.searching) {
        return api._searchAssets()
      }

      return api._clearSearch()
    }

    $scope.filters = filters
    api._searchAssets()
  }

  function _resetAllSections () {
    $scope.$broadcast('repository.load-assets-start')
    $scope.hasShowMoreButton = false
    $scope.pagination.$skip = 0

    $scope.searchSections[0].assets = []
    $scope.searchSections[0].totalCount = 0
    $scope.sections.forEach((section) => {
      section.assets = []
      section.totalCount = 0
    })
  }

  function _handleAdvancedSearch (term, tags = []) {
    $scope.searching = !!term || tags?.length

    if (!$scope.searching) {
      return api._clearSearch()
    }

    $scope.filters.tags = tags
    $scope.assetSearch = term
    api._searchAssets()
    api._setHeader()
  }

  function _onAdvancedSearchAssetClick (asset) {
    if (asset.cardType === 'folder') {
      return $state.go('repository.organizedFolder', {
        id: asset.id
      })
    }

    if (AssetPreviewService.assetPreviewIsOpen()) {
      return
    }

    const section = $scope.sections[1]
    const assetIndex = section.assets.findIndex(sectionAsset => sectionAsset.id === asset.id)

    AssetPreviewService.openAssetPreview({
      asset: asset,
      location: 'repository',
      getPreviewAssets: () => {
        return Promise.resolve({
          assets: [asset],
          count: 1
        })
      },
      onDeleteAsset: (asset) => {
        api._openMoveToTrashDialog(asset, section, assetIndex)
      }
    })
  }

  function _openMoveToTrashDialog (asset, section, assetIndex) {
    api.getMoveToTrashDialogController().then(({ MoveToTrashController }) => {
      const nameDisplayLength = 32
      const assets = [{
        id: asset.id,
        assetSize: Utils.getReadableFileSizeString(asset.size),
        assetName: RepositoryService.defineFullAssetNameToDisplay(asset, nameDisplayLength),
        assetIcon: RepositoryService.defineAssetIconBasedOnExtension(asset)
      }]

      const moveToTrashDialog = UdsModalService.createModal({
        controller: MoveToTrashController,
        modalName: 'moveToTrashDialog',
        data: {
          assets
        },
        onClose: hasMoved => {
          if (hasMoved) {
            api._removeAssetFromList(section, assetIndex)
            AssetPreviewService.closePreview()
          }
        }
      })

      moveToTrashDialog.open()
    })
  }

  function _removeAssetFromList (section, assetIndex) {
    $timeout(() => {
      section.assets.splice(assetIndex, 1) // remove asset from list
      section.totalCount--
    })
  }

  function _addFolder () {
    const { pricing } = event.currentTarget

    if (pricing) {
      return api._openPricingUpgradeDialog($translate.instant('createFolders'), 'REPOSITORIES.IMPORT_MATERIALS')
    }
    const parentId = $stateParams.id || null

    getCreateFolderDialogController().then(({ CreateFolderDialogController }) => {
      const createFolderDialog = UdsModalService.createModal({
        controller: CreateFolderDialogController,
        modalName: 'createFolderDialog',
        data: {
          parentId
        },
        onClose: (wasAdded) => {
          if (wasAdded) {
            api._loadFolders(false, parentId).then(() => {
              $scope.$broadcast('repository.load-assets-end')
            })
          }
        }
      })

      createFolderDialog.open()
    })
  }

  function _searchAssets () {
    api._trackSearch()
    api._resetAllSections()
    api._loadAssets($scope.breadcrumbs?.current?.id)
  }

  function _trackSearch () {
    const {
      tags,
      designers,
      createdBy,
      modules,
      assetId,
      createdAt,
      updatedAt,
      type
    } = $scope.filters
    const term = $scope.assetSearch

    SegmentService.track('file-search', {
      tab_name: 'Organizados',
      filter_text: term,
      filter_tag: tags,
      filter_permission: designers,
      filter_create_for: createdBy,
      filter_use_on: modules,
      filter_code_id: assetId,
      filter_create_date: createdAt,
      filter_update_date: updatedAt,
      filter_extension_type: type
    })
  }

  function _clearSearch () {
    if ($scope.initialLoad) {
      return
    }

    $scope.pagination.$skip = 0
    $scope.searching = false
    $scope.assetSearch = ''
    $scope.filters.tags = null
    $scope.$broadcast('repository.load-assets-start')

    api._setHeader()
    api._resetAllSections()
    api._loadAssets($scope.breadcrumbs?.current?.id)

    if (!api._hasFilterApplied($scope.filters)) {
      api._loadFolders(false, $scope.breadcrumbs?.current?.id)
    }
  }

  function _loadAssets (folderId) {
    return api._hasOrganizedAccess().then((hasAccess) => {
      if (!hasAccess) {
        $timeout(() => {
          $scope.$broadcast('repository.load-assets-end')
        })
        return
      }

      if (!folderId) {
        folderId = $scope.currentFolder?.id
      }

      if ($scope.showOnlyExtension && !Array.isArray($scope.showOnlyExtension)) {
        $scope.filters.extension = $scope.showOnlyExtension
      }

      if ($scope.removeExtensions) {
        $scope.filters.excludeExtensions = $scope.removeExtensions
      }

      const hasFilters = api._hasFilterApplied($scope.filters)
      let section = $scope.sections[1]
      let searchServiceFn = RepositoryService.getAllAssets
      const queryParams = {
        $sort: $scope.pagination.$sort,
        $order: $scope.pagination.$order,
        $top: $scope.pagination.$top,
        $skip: $scope.pagination.$skip,
        filters: $scope.filters,
        organized: true,
        folderId,
        hasFilters
      }

      if ($scope.searching) {
        section = $scope.searchSections[0]
        searchServiceFn = RepositoryService.searchOrganized

        queryParams.search = $scope.assetSearch
      }

      return searchServiceFn(queryParams, folderId)
        .then((assets) => {
          $scope.pagination.$skip = $scope.pagination.$skip += $scope.pagination.$top
          section.assets = section.assets.concat(assets.rows)
          section.totalCount = assets.count
          $scope.hasShowMoreButton = api._hasMoreResults(assets.count, section.assets.length)
          $scope.$broadcast('repository.load-assets-end')
        })
    })
  }

  function _loadFolders (isArchived = false, parentId = null) {
    return api._hasOrganizedAccess()
      .then((hasAccess) => {
        if (!hasAccess) {
          return
        }

        return RepositoryService.getFolders(parentId, isArchived)
          .then((folders) => {
            $scope.sections[0].assets = folders.rows
            $scope.sections[0].totalCount = folders.count
          })
      })
  }

  $scope.loadAssets = api._loadAssets

  function _hasMoreResults (totalCount, responseLength) {
    if (!responseLength) {
      return false
    }

    return Number(totalCount) > responseLength
  }

  function _hasFilterApplied (filters) {
    const hasFilterApplied = Object.keys(filters).some((key) => {
      const value = filters[key]

      if (Array.isArray(value) && value.length) {
        return true
      }

      if (!Array.isArray(value) && value !== '' && value !== null && value !== undefined) {
        return true
      }

      return false
    })

    return hasFilterApplied
  }

  function _setEmptyState (hasOrganizedAccess) {
    if (!hasOrganizedAccess) {
      $scope.emptyState = {
        imgPath: 'empty-state-' + $scope.currentPage,
        title: $translate.instant('repository.emptyState.noAccessOrganized.title'),
        message: $translate.instant('repository.emptyState.noAccessOrganized.message'),
        button: {
          type: 'primary',
          icon: '',
          text: 'repository.emptyState.noAccessOrganized.buttonText',
          click: api._openPricingUpgradeDialog.bind(this, $translate.instant('repository.sidebarSections.organized'), 'REPOSITORIES.ORGANIZED')
        }
      }

      return
    }

    $scope.emptyState = {
      imgPath: 'empty-state-' + $scope.currentPage,
      title: $translate.instant('repository.emptyState.organized.title'),
      message: $translate.instant('repository.emptyState.organized.message'),
      button: {
        type: 'primary',
        icon: $scope.modalState ? 'arrow-left' : 'plus',
        text: $scope.modalState ? 'backPage' : 'repository.emptyState.organized.buttonText',
        click: $scope.modalState ? api._handleGoBackFolder.bind() : api._addFolder.bind()
      }
    }
  }

  function _hasOrganizedAccess () {
    return RepositoryService.hasOrganizedAccess()
  }

  function _openPricingUpgradeDialog (featureName, featureSlug) {
    $rootScope.getCompanyWithBillingPackage().then(companyBillingPackage => {
      const isLegacy = Boolean(companyBillingPackage?.billingPackage?.plan?.pricingPackage?.legacy)

      if (!isLegacy) {
        return api.getUpgradeCompanyPlanDialogController().then(({ UpgradeCompanyPlanDialogController }) => {
          const modal = UdsModalService.createModal({
            controller: UpgradeCompanyPlanDialogController,
            modalName: 'upgradeCompanyPlanDialog',
            data: {
              featureName,
              featureSlug
            }
          })

          modal.open()
        })
      }

      return api.getModulesPricingDialogController().then(({ ModulesPricingDialogController }) => {
        const modal = UdsModalService.createModal({
          controller: ModulesPricingDialogController,
          modalName: 'modulesPricingDialog',
          data: {
            module: {
              icon: 'files'
            }
          }
        })

        modal.open()
      })
    })
  }

  function _handlePricing () {
    return $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
      const hasImportFilesFeature = !!features[String('REPOSITORIES.IMPORT_MATERIALS')]

      $scope.companyFeatures.importFiles.access = hasImportFilesFeature
    })
  }

  function _openChooseDocTemplateDialog () {
    api.getChooseDocTemplateDialogController().then(({ ChooseDocTemplateDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: ChooseDocTemplateDialogController,
        modalName: 'chooseDocTemplateDialog',
        data: {
          location: 'repository',
          folderId: $scope.breadcrumbs?.current?.id
        }
      })
      modal.open()
    })
  }
}

export { OrganizedController }
